import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import prepareHeaders from '../utils/prepareHeaders'

export const namedLocationTemplatesApi = createApi({
  reducerPath: 'namedLocationTemplates',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getNamedLocationTemplateDeployPreview: builder.query({
      query: ({ templateId, customerIds }) => ({
        url: `/secure/policy/template/${templateId}/named-location-deploy/preview`,
        params: { customerIds: customerIds.join(',') },
      }),
    }),
    deployNamedLocationTemplate: builder.mutation({
      query: ({ templateId, customerIds, chosenCandidates, contentChoices, userId }) => ({
        url: `/secure/policy/template/${templateId}/named-location-deploy`,
        method: 'POST',
        params: { userId },
        body: { customerIds, chosenCandidates, contentChoices },
      }),
    }),
  }),
})

export const { useLazyGetNamedLocationTemplateDeployPreviewQuery, useDeployNamedLocationTemplateMutation } =
  namedLocationTemplatesApi
